<template>
  <div class="Api">
    <div style="display: inline-flex;justify-content: space-between;width: 100%;">
      <SearchForm :fields="searchFields" :searchFrom="{systemCode: ''}" @submit="handleSubmit"></SearchForm>
      <content-title style="width: 200px;">
        <template v-slot:other>
        <div style="display: flex;color: rgba(0, 0, 0, 0.45);top: 1px;">
          <div class="refresh"
            v-tooltip="{
              content: `<div>${$t('common_刷新')}</div>`,
              html: true,
              placement: 'bottom'
            }"
          >
            <a-icon type="reload" @click="fetch" style="font-size: 14px;" />
          </div>
        </div>
      </template>
      </content-title>
    </div>
    <a-alert v-if="apiNum !== undefined" :message="`剩余API数量：${apiNum}`" type="info" :style="{ marginBottom: '12px' }" />
    <smart-table
      ref="smartTable"
      :base-url="baseURL"
      :api-path="apiPath"
      :default-param="defaultParam"
      :param="param"
      :columns="columns"
      :bordered="false"
      :row-key="(record, index) => index"
      :scroll="{ y: 600 }"
    >
      <template slot="num" slot-scope="text, record, index">
        <div>{{(($refs.smartTable.pagination.current - 1) * $refs.smartTable.pagination.pageSize) + (index + 1)}}</div>
      </template>
      <template slot="titles" slot-scope="text, record">
        <span class="api-table__title" @click="toDocumnet(record)">{{record.title}}</span>
      </template>
      <template slot="isCharge" slot-scope="text, record">
        <span v-if="record.isCharge === 1">{{$t('apiList_收费')}}</span>
        <span v-else>{{$t('apiList_免费')}}</span>
      </template>
    </smart-table>
  </div>
</template>

<script>
import {
  SystemList,
  queryList
  // QueryApiNum
} from '@/api/login'
import { openNotificationWithIcon } from '@/utils/util'
import SmartTable from '@/components/SmartTable_next'
import SearchForm from '@/components/SearchForm'
import { mapState } from 'vuex'
import api from '@/api/index'
import ContentTitle from '@/components/ContentTitle.vue'

export default {
  name: 'InterDiary',
  data () {
    return {
      baseURL: api.baseURL,
      apiPath: api.docQueryListForApi,
      defaultParam: {},
      param: {},
      columns: [
        { title: 'No.', key: 'num', dataIndex: 'num', scopedSlots: { customRender: 'num' }, align: 'left', width: 60 },
        { title: this.$t('apiList_系统'), key: 'systemName', dataIndex: 'systemName', scopedSlots: { customRender: 'systemName' }, align: 'left', width: 100 },
        { title: this.$t('apiList_API名称'), key: 'title', dataIndex: 'title', scopedSlots: { customRender: 'titles' }, ellipsis: true, align: 'left', width: 120 },
        { title: this.$t('apiList_描述'), key: 'interfaceDesc', dataIndex: 'interfaceDesc', scopedSlots: { customRender: 'interfaceDesc' }, ellipsis: true, align: 'left', width: 130 }
      ],
      loading: false,
      current: 1,
      systemName: this.$t('common_home_announcement_type0'),
      systemArray: [],
      apiArray: [],
      appName: '',
      systemCode: '',
      total: 0, // 总数
      apiNum: undefined
    }
  },
  components: {
    SmartTable,
    ContentTitle,
    SearchForm
  },
  computed: {
    ...mapState({
      'menus': state => state.isLogin.menus,
      currentLang: state => state.isLogin.lang,
      'meunList': state => state.isLogin.meunList
    }),
    searchFields () {
      return [
        { type: 'select', name: 'systemCode', placeholder: this.$t('developer_pleaseSelect'), options: this.systemArray },
        { type: 'text', name: 'title', placeholder: this.$t('apiList_接口名称') }
      ]
    }
  },
  mounted () {
    SystemList({}).then((res) => {
      if (res.code === '200') {
        this.systemArray = res.data
        this.systemArray.unshift({
          systemName: this.$t('common_conj_all', ['']),
          systemCode: ''
        })
        this.systemArray = this.systemArray.map(item => {
          return {
            label: item?.systemName,
            value: item?.systemCode
          }
        })
        this.fetch()
      } else {
        openNotificationWithIcon(res.message)
      }
    })
    // QueryApiNum({}).then((res) => {
    //   console.log('QueryApiNum', res)
    //   if (res.code === '200') {
    //     this.apiNum = res.data
    //   }
    // })
  },
  methods: {
    fetch () {
      this.$refs.smartTable.fetch()
    },
    toDocumnet (item) {
      // // this.$store.commit('APITODOC', item)
      // let defaultOpenKeys = val.map(item => '0-' + item.catalogId)
      // let catalogId = [...new Set([...defaultOpenKeys, ...item.catalogId])]
      // console.log(this.findMenuParentId(this.menus, item.catalogId))
      this.$store.commit('SET_MENUS_isLoading', true)
      queryList({
        platformCodeBind: 'OPEN_API_PORTAL'
      }).then((res) => {
        if (res.code === '200') {
          if (res.data) {
            this.$store.dispatch('setMenus', res.data)
            this.$router.push({
              path: '/documentCenter',
              query: {
                docId: item.documentId + '',
                catId: item.level === 2 ? `0-${item.catalogId}-${item.catalogId},0-${this.findMenuParentId(this.menus, item.catalogId)}` : `0-${item.catalogId}`
              }
            })
          }
        } else {
          openNotificationWithIcon(res.message)
        }
      }).finally(() => {
        this.$store.commit('SET_MENUS_isLoading', false)
      })
    },
    findMenuParentId (list, catalogId, parentId) {
      let ss = ''
      for (let item of list) {
        if (`${item.catalogId}` === `${catalogId}`) {
          return item.parentId
        }
        if (item.childCatalog instanceof Array) {
          ss = this.findMenuParentId(item.childCatalog, catalogId)
          if (ss) return ss
        }
      }
      return null
    },
    // searchApi () {
    //   this.param = { systemCode: this.systemCode, title: this.appName }
    // },
    handleSubmit (val) {
      this.param = { ...val, pageNum: 1 }
    },
    // pageChange (current) {
    //   this.current = current
    //   this.Apilist(current)
    // },
    // Apilist (current) {
    //   let data = {
    //     documentType: 2,
    //     pageNum: current,
    //     pageSize: 10,
    //     systemCode: this.systemCode,
    //     title: this.appName
    //   }
    //   docQueryListForApi(data).then((res) => {
    //     if (res.code === '200') {
    //       this.apiArray = res.dataList ? res.dataList : []
    //       this.total = res.total
    //     } else {
    //       openNotificationWithIcon(res.message)
    //     }
    //   })
    // },
    // 选择平台
    handleChange (value, event) {
      this.systemName = value
      this.systemCode = event.data.attrs.systemCode
      // console.log(`selected ${value}`)
    }
  }
}
</script>
<style lang="less" scoped>
.Api {
  text-align: left;
  background-color: #fff;
  padding:  0;
}
.api-table__title {
  cursor: pointer;
  color: #4978D6;
}
.Api-title__filter {
  margin-bottom: 30px;
}
.list-table {
  background: #F0F0F0;
  height: 30px;
  line-height: 30px;
    font-weight:500;
  margin-right: 24px;
  span {
    display: inline-block;
    text-align: center;
    &:nth-child(1) {
      width: 176px;
      border-right: 1px solid #fff;
    }
    &:nth-child(2) {
      width: 184px;
      border-right: 1px solid #fff;
    }
    &:nth-child(3) {
      width: 560px;
    }
  }
}
.app-ul {
  margin-right: 24px;
  min-height: 500px;
  .app-li {
    font-size: 0px;
    color: #555555;
    border-bottom: 1px solid rgba(240,240,240,1);
    span {
      font-size:12px;
      display: inline-block;
      height: 40px;
      line-height: 40px;
      text-align: center;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      padding: 0 4px;
      &:nth-child(1) {
        cursor: pointer;
        width: 176px;
        border-right: 1px solid #fff;
        color: #4978D6;
      }
      &:nth-child(2) {
        width: 184px;
        border-right: 1px solid #fff;
      }
      &:nth-child(3) {
        width: 560px;
      }
    }
    .charge {
        color: #000;
    }
  }
}
.login-btn {
  margin-left: 25px;
  width:83px;
  height:32px;
  font-size: 14px;
  border-radius: 2px;
}
.login-bga {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.26);
  z-index: 9;
  color: #282828;
}
.login-boxs {
  width:760px;
  // height:351px;
  position: absolute;
  left: 50%;
  top:50%;
  transform:translate(-50%,-50%);
  background:rgba(255,255,255,1);
  overflow-y: auto;
  height: 600px;
}
.list-content {
  margin-top: 45px;
}
.login-close {
  position: absolute;
  right: 29px;
  top: 17px;
  width: 19px;
  height: 32px;
}
.login-close:before, .login-close:after {
  position: absolute;
  left: 15px;
  content: ' ';
  height: 20px;
  width: 2px;
  background-color: #999999;
}
.login-close:before {
  transform: rotate(45deg);
}
.login-close:after {
  transform: rotate(-45deg);
}
.top-t {
  padding: 14px 20px;
  font-size: 16px;
  border-bottom: 1px solid #eee;
  position: relative;
  font-weight: 400;
}
.info {
  margin-top: 15px;
  font-weight: 600;
  margin-bottom: 15px;
}
.known {
  font-size:12px;
 i {
   color: #E02020;
 }
}
.login-text {
  width:270px;
  height:91px;
}
.login-input {
  margin-left: 25px;
  width:150px;
  height:32px;
  font-size:12px;
  color: #989898;
  /deep/ .ant-input {
    font-size: 12px;
  }
}
.Api_no_list {
  text-align: center;
  margin-top: 203px;
  color: #999999;
  font-size:24px;
  font-family:PingFangSC-Semibold,PingFang SC;
  font-weight:600;
}
.refresh {
  width: 30px;
  height: 30px;
  background: #FFFFFF;
  border-radius: 2px;
  border: 1px solid #D9D9D9;
  font-size: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.refresh:hover {
  transition: 0.4s;
  border: 1px solid #80b3ff;
  color: #80b3ff;
}
/deep/.ant-select-arrow /deep/.ant-select-arrow-icon {
  font-size: 12px;
}
</style>
